export class TaskCanceled extends Error {
  constructor(taskId) {
    super(taskId);
  }
}
//# sourceMappingURL=TaskCanceled.js.map
